import { Component, Input } from '@angular/core';
import { AppTranslatePipe } from '@app/pipes/app-translate.pipe';
import { Translatable } from '@app/types/translatable.type';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.template.html',
    standalone: true,
    imports: [AppTranslatePipe],
    styleUrls: ['./empty-state.style.scss'],
})
export class EmptyStateComponent {
    @Input() src: string;
    @Input() label: Translatable = 'components.empty-state.noDataAvailable';
}
